export default {
  'component_refresh_btn_name': 'Refresh',
  'component_refresh_tips': 'Click to refresh or auto refresh every 5 minutes.',
  'component_refresh_tips_10min': 'Click to refresh or auto refresh every 10 minutes.',
  'component_refresh_success_msg': 'Refresh successfully',
  'component_refresh_error_msg': 'Refresh failed',
  'component_refresh_tips_1hour': 'Click to refresh or auto refresh every 1 hour.',
}
